import type { ReactNode } from 'react';

import { DatePicker } from '@zen/DesignSystem';
import type { Matcher, TooltipConfig } from '@zen/DesignSystem/types';

import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

interface FormFieldType {
  error: string;
  name: string;
  value: string;
}

interface Props extends FormFieldProps {
  additionalInfo?: ReactNode;
  disabled?: Matcher;
  isInline?: boolean;
  numberOfMonths?: number;
  onChange?: (value: string) => void;
  tooltip?: TooltipConfig | TooltipConfig[];
}

const FormDatePicker = ({ additionalInfo, className, onChange, ...rest }: Props) => {
  return (
    <FormField {...rest}>
      {(field: FormFieldType, form: FormInstance<unknown>) => (
        <DatePicker
          additionalInfo={additionalInfo}
          className={className}
          disabled={rest.disabled}
          hasError={!!field.error}
          isInline={rest.isInline}
          mode="single"
          numberOfMonths={rest.numberOfMonths}
          onChange={(value: string) => {
            form.setFieldValue(field.name, value);

            onChange?.(value);
          }}
          selected={field.value}
          tooltip={rest.tooltip}
        />
      )}
    </FormField>
  );
};

export default FormDatePicker;
